import React, { useState } from 'react';
import classes from './RadioButtonNavList.module.scss';
import Button from '@/components/Button/Button';

const RadioButtonNavList = ({ additionalClasses, answers, type, ...props }) => {
  const [selected, setSelected] = useState(null);
  const t = props.t;

  const selectAndClick = (value, link) => {
    if (link) {
      window.open(link?.href, link?.target || '_self');
    } else {
      props.onSelect(props.element.answerType, value);
    }
    return setSelected(value);
  };

  return (
    <>
      <label htmlFor={props.name} className={classes[`${props.element.controlType}-label`]}>
        {props.element.label}
      </label>
      <ul className={classes.RadioButtonNavList} id={props.name}>
        {props.element.options.map((btn, index) => {
          return (
            <li key={index} className={classes[btn.width]}>
              <Button
                additionalClasses={`${additionalClasses} ${
                  selected === btn.value || (!selected && [answers.userType, answers.supportType].includes(btn.value)) ? classes.active : ''
                }`}
                text={t(btn.label, { answers: answers })}
                onButtonClick={() => {
                  selectAndClick(btn.value, btn.link);
                }}
                styles={{ width: 'full' }}
                dataCy={`button-${btn.label.replace(/\s+/g, '-').toLowerCase()}`}
              />
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default RadioButtonNavList;
